// UnknownBirth.jsx
import FormCheckbox from '@/shared-components/inputs/components/FormCheckbox';
import Text from '@/shared-components/text/components/Text';

import './styles/UnknownBirth.css';

export default function UnknownBirth({ loading, isUnknown, onToggle }) {
  return (
    <div className="artist-unknown__check-container">
      <FormCheckbox
        readOnly={loading}
        value={isUnknown}
        onChange={onToggle}
        className="artist-unknown__checkbox"
      />
      <Text className="artist-unknown__text font-size-small">
        The year of birth is unknown
      </Text>
    </div>
  );
}
